import classNames from "classnames";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";

type Props = {
  to: string;
  icon: any;
  label: any;
};

function HeaderItem({ to, icon, label }: Props) {
  const resolvedTo = useResolvedPath(to + "/*");
  const matchTo = useMatch({ path: resolvedTo.pathname });

  const className = classNames(
    "h-max md:w-[150px] py-3 md:px-5 px-2 flex items-center justify-center text-primary md:hover:bg-[#4ab6c6] md:hover:text-white",
    {
      "border-[#4ab6c6] border-b-2": matchTo,
    }
  );
  return (
    <NavLink to={to} className={className}>
      <div className="flex gap-5 items-center">
        {icon}
        <p className="md:block hidden">{label}</p>
      </div>
    </NavLink>
  );
}

export default HeaderItem;
